import React from 'react';
export function PurchaseSteps() {
  return <section className="w-full bg-[#0a0a0a] py-6 px-4 border-t border-gray-800" data-id="element-327">
      <div className="max-w-xl mx-auto text-center" data-id="element-328">
        <p className="text-sm md:text-base font-bold text-white font-heading mb-4" data-id="element-329">
          Estás a 1 paso de acceder al MegaPack:
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-2 max-w-md mx-auto" data-id="element-330">
          <div className="flex items-center gap-2.5 bg-gray-900 border border-gray-800 rounded-lg px-3 py-2.5 flex-1" data-id="element-331">
            <div className="bg-yellow-400/15 border border-yellow-400/40 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0" data-id="element-332">
              <span className="text-yellow-400 font-black text-xs" data-id="element-333">1</span>
            </div>
            <p className="text-gray-300 font-body text-xs font-medium" data-id="element-334">
              Completa tus datos
            </p>
          </div>
          <div className="flex items-center gap-2.5 bg-gray-900 border border-gray-800 rounded-lg px-3 py-2.5 flex-1" data-id="element-335">
            <div className="bg-yellow-400/15 border border-yellow-400/40 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0" data-id="element-336">
              <span className="text-yellow-400 font-black text-xs" data-id="element-337">2</span>
            </div>
            <p className="text-gray-300 font-body text-xs font-medium" data-id="element-338">
              Realiza el pago seguro
            </p>
          </div>
          <div className="flex items-center gap-2.5 bg-gray-900 border border-gray-800 rounded-lg px-3 py-2.5 flex-1" data-id="element-339">
            <div className="bg-yellow-400/15 border border-yellow-400/40 rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0" data-id="element-340">
              <span className="text-yellow-400 font-black text-xs" data-id="element-341">3</span>
            </div>
            <p className="text-gray-300 font-body text-xs font-medium" data-id="element-342">
              Accede Inmediatamente
            </p>
          </div>
        </div>
      </div>
    </section>;
}